// extracted by mini-css-extract-plugin
module.exports = {"image":"formula_image__28X5B","formulaWrapper":"formula_formulaWrapper__k3wYF"};